/**
 * StorageManager类
 * 管理本地存储
 */

import type { GameStateData } from './types';
import { STORAGE_KEYS } from './constants';

export class StorageManager {
  /**
   * 获取游戏状态
   * @returns 游戏状态数据或null
   */
  public getGameState(): GameStateData | null {
    try {
      const stateStr = localStorage.getItem(STORAGE_KEYS.GAME_STATE);
      if (!stateStr) {
        return null;
      }
      return JSON.parse(stateStr) as GameStateData;
    } catch (error) {
      console.error('读取游戏状态失败:', error);
      return null;
    }
  }

  /**
   * 保存游戏状态
   * @param state 游戏状态数据
   */
  public setGameState(state: GameStateData): void {
    try {
      const stateStr = JSON.stringify(state);
      localStorage.setItem(STORAGE_KEYS.GAME_STATE, stateStr);
    } catch (error) {
      console.error('保存游戏状态失败:', error);
    }
  }

  /**
   * 清除游戏状态
   */
  public clearGameState(): void {
    try {
      localStorage.removeItem(STORAGE_KEYS.GAME_STATE);
    } catch (error) {
      console.error('清除游戏状态失败:', error);
    }
  }

  /**
   * 获取最高分
   * @returns 最高分
   */
  public getBestScore(): number {
    try {
      const scoreStr = localStorage.getItem(STORAGE_KEYS.BEST_SCORE);
      if (!scoreStr) {
        return 0;
      }
      return parseInt(scoreStr, 10) || 0;
    } catch (error) {
      console.error('读取最高分失败:', error);
      return 0;
    }
  }

  /**
   * 保存最高分
   * @param score 分数
   */
  public setBestScore(score: number): void {
    try {
      localStorage.setItem(STORAGE_KEYS.BEST_SCORE, score.toString());
    } catch (error) {
      console.error('保存最高分失败:', error);
    }
  }

  /**
   * 更新最高分（只在新分数更高时更新）
   * @param score 当前分数
   * @returns 是否更新了最高分
   */
  public updateBestScore(score: number): boolean {
    const bestScore = this.getBestScore();
    if (score > bestScore) {
      this.setBestScore(score);
      return true;
    }
    return false;
  }
}
